/** biome-ignore-all lint/complexity/noStaticOnlyClass: ngxs states */
import type { TestStateRequestBody } from '../../../services/api/models/TestStateModel';
import type { TestPhaseItem } from './test-phase.state.model';

/**
 * Action to load test phases from the API for the given group IDs
 */
export class LoadTestPhases {
  static readonly type = '[TestPhase] Load Test Phases';
}

/**
 * Action to set loaded test phases
 */
export class SetTestPhases {
  static readonly type = '[TestPhase] Set Test Phases';
  constructor(public readonly phases: TestPhaseItem[]) {}
}

/**
 * Action to toggle visibility of a specific phase by identifier
 */
export class TogglePhaseVisibility {
  static readonly type = '[TestPhase] Toggle Phase Visibility';
  constructor(public readonly phaseId: string) {}
}

/**
 * Action to set loading state
 */
export class SetTestPhaseLoading {
  static readonly type = '[TestPhase] Set Loading';
  constructor(public readonly isLoading: boolean) {}
}

/**
 * Action to set error state
 */
export class SetTestPhaseError {
  static readonly type = '[TestPhase] Set Error';
  constructor(public readonly error: string | null) {}
}

/**
 * Action to reset all test phase state
 */
export class ResetTestPhaseState {
  static readonly type = '[TestPhase] Reset State';
}

/**
 * Action to show all phases (reset hidden phases)
 */
export class ShowAllPhases {
  static readonly type = '[TestPhase] Show All Phases';
}

/**
 * Action to hide all phases
 */
export class HideAllPhases {
  static readonly type = '[TestPhase] Hide All Phases';
}

/**
 * Action to create a new test state via POST API
 */
export class CreateTestPhase {
  static readonly type = '[TestPhase] Create Test Phase';
  constructor(
    public readonly groupId: string,
    public readonly body: TestStateRequestBody
  ) {}
}

/**
 * Action to update an existing test state via PATCH API
 */
export class UpdateTestPhase {
  static readonly type = '[TestPhase] Update Test Phase';
  constructor(
    public readonly testStateId: string,
    public readonly body: TestStateRequestBody
  ) {}
}

/**
 * Action to delete an existing test state via DELETE API
 */
export class DeleteTestPhase {
  static readonly type = '[TestPhase] Delete Test Phase';
  constructor(public readonly testStateId: string) {}
}

/**
 * Action to approve a test state via PATCH approval API
 */
export class ApproveTestPhase {
  static readonly type = '[TestPhase] Approve Test Phase';
  constructor(public readonly testStateId: string) {}
}

/**
 * Action to reset all non-approved test phases to their original API values.
 * Only phases where current values differ from the originals will be patched.
 */
export class ResetAllTestPhasesToOriginal {
  static readonly type = '[TestPhase] Reset All To Original';
}

/**
 * Action to highlight a specific test phase in the chart on hover
 */
export class HighlightTestPhase {
  static readonly type = '[TestPhase] Highlight Test Phase';
  constructor(public readonly identifier: string) {}
}

/**
 * Action to remove the highlight from a test phase in the chart
 */
export class DownplayTestPhase {
  static readonly type = '[TestPhase] Downplay Test Phase';
}
